class ProductRestrictions extends window.HTMLElement {
  constructor() {
    super();
    this.states = this.dataset.states ? this.dataset.states.split(',') : [];
  }

  connectedCallback() {
    if (this.states.length > 0) {
      this.fetchRestrictions();
    }
  }

  async fetchRestrictions() {
    const states = this.states.map((state) => this.stateMapping(state));
    try {
      const response = await fetch('https://get.geojs.io/v1/ip/geo.json');
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
      }
      const location = await response.json();
      if (location?.region) {
        const stateMapped = this.stateMapping(location.region);
        if (states.includes(location.region) || states.includes(stateMapped)) {
          this.dataset.init = 'true';
          let message = this.innerHTML;
          message = message.replace('/location/', states.join(', '));
          this.innerHTML = message;
        }
      }
    } catch (error) {
      console.error(
        'There has been a problem with your fetch operation:',
        error
      );
    }
  }

  stateMapping(state) {
    switch (state.toUpperCase()) {
      case 'AL':
        return 'Alabama';
      case 'AK':
        return 'Alaska';
      case 'AZ':
        return 'Arizona';
      case 'AR':
        return 'Arkansas';
      case 'CA':
        return 'California';
      case 'CO':
        return 'Colorado';
      case 'CT':
        return 'Connecticut';
      case 'DE':
        return 'Delaware';
      case 'FL':
        return 'Florida';
      case 'GA':
        return 'Georgia';
      case 'HI':
        return 'Hawaii';
      case 'ID':
        return 'Idaho';
      case 'IL':
        return 'Illinois';
      case 'IN':
        return 'Indiana';
      case 'IA':
        return 'Iowa';
      case 'KS':
        return 'Kansas';
      case 'KY':
        return 'Kentucky';
      case 'LA':
        return 'Louisiana';
      case 'ME':
        return 'Maine';
      case 'MD':
        return 'Maryland';
      case 'MA':
        return 'Massachusetts';
      case 'MI':
        return 'Michigan';
      case 'MN':
        return 'Minnesota';
      case 'MS':
        return 'Mississippi';
      case 'MO':
        return 'Missouri';
      case 'MT':
        return 'Montana';
      case 'NE':
        return 'Nebraska';
      case 'NV':
        return 'Nevada';
      case 'NH':
        return 'New Hampshire';
      case 'NJ':
        return 'New Jersey';
      case 'NM':
        return 'New Mexico';
      case 'NY':
        return 'New York';
      case 'NC':
        return 'North Carolina';
      case 'ND':
        return 'North Dakota';
      case 'OH':
        return 'Ohio';
      case 'OK':
        return 'Oklahoma';
      case 'OR':
        return 'Oregon';
      case 'PA':
        return 'Pennsylvania';
      case 'RI':
        return 'Rhode Island';
      case 'SC':
        return 'South Carolina';
      case 'SD':
        return 'South Dakota';
      case 'TN':
        return 'Tennessee';
      case 'TX':
        return 'Texas';
      case 'UT':
        return 'Utah';
      case 'VT':
        return 'Vermont';
      case 'VA':
        return 'Virginia';
      case 'WA':
        return 'Washington';
      case 'WV':
        return 'West Virginia';
      case 'WI':
        return 'Wisconsin';
      case 'WY':
        return 'Wyoming';
      case 'NB':
        return 'New Brunswick';
      default:
        return state;
    }
  }
}

window.customElements.define('product-restrictions', ProductRestrictions);
